export default "__VITE_ASSET__a267d579__"